"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterPresetEnum = void 0;
var FilterPresetEnum;
(function (FilterPresetEnum) {
    FilterPresetEnum["OVERDUE_INVOICES"] = "overdue_invoices";
    FilterPresetEnum["MY_TODO"] = "my_todo";
    FilterPresetEnum["MY_REQUESTS"] = "my_requests";
    FilterPresetEnum["MY_MENTIONS"] = "my_mentions";
    FilterPresetEnum["FOLLOW_UP_REQUESTS"] = "follow_up_requests";
    FilterPresetEnum["DRAFT_TRIP_FOLDER"] = "draft_trip_folder";
})(FilterPresetEnum || (exports.FilterPresetEnum = FilterPresetEnum = {}));
